import { useState, useEffect } from "react";
import { errorLabels } from "../../../../../utils/helpers";
import { ErrorMessage } from "../../../../../utils/toastify";
import { useFormRCSCustomers } from "./useFormRCSCustomers";
import { useGetRCSReportByCustomers } from "./useGetRCSReportByCustomers";

export const useRCSReportByCustomers = () => {
  const { mutate, isPending, data = [] } = useGetRCSReportByCustomers();
  const [reset, setReset] = useState(false);
  const formik = useFormRCSCustomers({
    onSubmit: mutate,
  });

  const _validate = async () => {
    try {
      const isValid = await formik.validateForm();
      const errors = errorLabels(isValid);

      if (Object.keys(isValid).length !== 0) {
        throw new Error(`Campos inválidos: ${errors}`);
      }
      await formik.submitForm();
    } catch (error) {
      ErrorMessage(error.message);
    }
  };

  const handleReset = () => {
    formik.resetForm();
    setReset(true);
  };

  useEffect(() => {
    if (reset) {
      setReset(false);
    }
  }, [reset]);

  return {
    formik,
    reset,
    isLoading: isPending,
    _validate,
    handleReset,
    data,
  };
};
